import React from 'react';
import { Button, Container, Field, HeaderSection, Text } from '@groupelacentrale/contact-storybook';
import './PhoneValidationForm.scss';
import { keypressCallback } from 'utils';

interface Props {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void | undefined;
  phone: string;
  blocked?: boolean;
  code: string;
  error?: string;
  isSubmitting: boolean;
  handleSubmit: () => void | undefined;
  onResend: () => void | undefined;
  onReturn: () => void | undefined;
}

export const PhoneValidationFormView: React.FC<Props> = ({
  handleChange,
  phone,
  blocked,
  code,
  error,
  isSubmitting,
  handleSubmit,
  onResend,
  onReturn,
}) => {
  const handleKeyPress = keypressCallback(onResend, '');
  return (
    <Container shadowed paddings="mediumP" backgroundColor="bgWhite" className="phone-validation-form">
      <form onSubmit={handleSubmit}>
        <HeaderSection noUnderline>Validation de votre numéro de téléphone</HeaderSection>
        <Text>
          Pour valider votre numéro ({phone}), veuillez saisir le code à 6 chiffres qui vous a été envoyé par SMS :
        </Text>
        <div className="validation-field-wrapper">
          <Field name="code" onChange={handleChange} value={code} errorMessage={error} />
          <Text
            className="resend-handle"
            onClick={blocked ? undefined : onResend}
            tabIndex={0}
            onKeyPress={handleKeyPress}
          >
            Je n&apos;ai pas reçu le code
          </Text>
        </div>
        <div className="actions">
          <Button label="Retour" theme="quaternary" type="button" onClick={onReturn} />
          <Button
            label="Valider et continuer"
            type="submit"
            theme="primary"
            disabled={!code || isSubmitting || blocked}
            loading={isSubmitting}
          />
        </div>
      </form>
    </Container>
  );
};
